export default __webpack_public_path__ + "static/media/underline.e5e6a428.svg";